import WarehouseSection from './WarehouseSection'

export default WarehouseSection
